import {identifyWellID} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';
import _ from 'lodash';
import {memo} from 'react';
import PropTypes from 'prop-types';
import {WELL_HOVER_TYPE} from 'constants/dataEnum';
import Well from '../Well';
import './CalculatedWell.scss';

function CalculatedWell({
  ID,
  wellKey,
  wellHoverMode,
  wellHovered,
  style = {},
  onMouseLeave = () => {},
  onClickWell = () => {},
  onMouseDown = () => {},
  onMouseEnter = () => {},
}) {
  const {row, column} = identifyWellID(ID);

  const charIndex = String.fromCharCode(64 + row);
  const wellText = wellHovered ? `${charIndex}${column}` : '';

  return (
    <div
      key={`container-${wellKey || ID}`}
      className="calculated-well-wrapper"
      onMouseLeave={(evt) => onMouseLeave(evt, ID)}
      onClick={(evt) => onClickWell(evt, ID)}
      onMouseDown={(evt) => onMouseDown(evt, ID)}
      onMouseEnter={(evt) => onMouseEnter(evt, ID)}
      onTouchStart={(evt) => onMouseDown(evt, ID)}
    >
      <Well
        id={wellKey || ID}
        background={style?.background}
        color={style?.color}
        border={style?.border}
        borderSize={style?.borderSize}
        containerColor={style?.containerColor}
        opacity={style?.opacity}
        wellText={wellText}
        showWellText={wellHoverMode === WELL_HOVER_TYPE.TEXT || wellHoverMode === WELL_HOVER_TYPE.BOTH}
      />
    </div>
  );
}

CalculatedWell.propTypes = {
  ID: PropTypes.string.isRequired,
  wellKey: PropTypes.string,
  wellHoverMode: PropTypes.string,
  wellHovered: PropTypes.bool,
  style: PropTypes.shape({
    background: PropTypes.string,
    color: PropTypes.string,
    border: PropTypes.string,
    borderSize: PropTypes.string,
    containerColor: PropTypes.string,
    opacity: PropTypes.number,
  }),
  onMouseLeave: PropTypes.func,
  onClickWell: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

CalculatedWell.defaultProps = {
  wellKey: '',
  style: {},
  wellHoverMode: null,
  wellHovered: false,
  onMouseLeave: () => {},
  onClickWell: () => {},
  onMouseDown: () => {},
  onMouseEnter: () => {},
};

function areEqual(prevProps, nextProps) {
  return (
    _.isEqual(prevProps.wellKey, nextProps.wellKey) &&
    _.isEqual(prevProps.style, nextProps.style) &&
    _.isEqual(prevProps.wellHoverMode, nextProps.wellHoverMode) &&
    _.isEqual(prevProps.wellHovered, nextProps.wellHovered)
  );
}

export default memo(CalculatedWell, areEqual);
